module.exports = __webpack_public_path__ + "img/logointerna.03354985.png";